export const toDate = (value) => {
  if (!value) return null;

  if (typeof value.toDate === 'function') {
    const converted = value.toDate();
    return Number.isNaN(converted?.getTime?.()) ? null : converted;
  }

  const converted = value instanceof Date ? value : new Date(value);
  return Number.isNaN(converted.getTime()) ? null : converted;
};

export const formatDate = (value, fallback = 'Non renseignée') => {
  const date = toDate(value);
  return date ? date.toLocaleDateString('fr-FR') : fallback;
};
